export const authRoles = {  
  admin: ['admin'],  
  purchase: ['purchase'],  
  sales: ['sales'],  
  orders: ['orders'],  
  store: ['store'],
  storepurchase: ['storepurchase']  
};